<template>
    <div>
        <card-header title="Edit User" icon="fa-pencil" />

        <card-toolbar v-if="currentUser.isSuper">
            <button @click="switchAndRedirect"><i class="far fa-user-circle"></i>Login as User</button>
        </card-toolbar>

        <card-body>
            <org-user-form :org="org" :user="user "/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteUser"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete User?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!user.first_name || !user.last_name || !user.username"
                    ><i class="fas fa-check mr-2"></i>Save User
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import ConferenceForm from "@/cards/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import moment from "moment";
    import OrgUserForm from "./UserForm.vue";
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {OrgUserForm, ConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                org: {},
                user: {},
                confirmDelete: false,
                dirty: null
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['switchUser']),
            loadUser: function () {
                this.$emit('loading', true);
                http.get('portal-users/' + this.props.userId, {force: true}).then(response => {
                    this.user = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            loadOrg: function() {
                this.$emit('loading', true);
                http.get('organizations/self', {force: true}).then(response => {
                    this.org = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            switchAndRedirect: function() {
                if (!this.currentUser.isSuper) return;
                this.switchUser({ portal_id: this.props.userId }).then(() => {
                    this.$resetCards();
                });
            },
            submit: function () {
                http.put('portal-users/' + this.props.userId, {
                    username: this.user.username,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    password: this.user.password,
                    content_provider_id: this.user.content_provider_id,
                    is_approval_committee: this.user.is_approval_committee,
                    role: this.user.role
                }, {force: true}).then(response => {
                    this.$reloadCard('org-settings');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the user.');
                    this.$emit('loading', false);
                });
            },
            deleteUser() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('portal-users/' + this.props.userId).then(response => {
                        this.$reloadCard('org-settings');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.userId': function () {
                this.dirty = null;
                this.loadUser();
            },
            'user': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this user? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadUser();
            this.loadOrg();
        }
    };
</script>
